import { REQUEST_MOBILE_APPS, RECEIVE_MOBILE_APPS } from '../constants/action-types'

const mobileAppsReducer = (
  state = {
    isRequestingMobileApps: false,
    requestMobileAppsError: false,
    data: [],
    pages: -1
  },
  action
) => {
  switch (action.type) {
    case REQUEST_MOBILE_APPS:
      return Object.assign({}, state, {
        isRequestingMobileApps: true
      })
    case RECEIVE_MOBILE_APPS:
      return Object.assign({}, state, {
        isRequestingMobileApps: false,
        requestMobileAppsError: action.error,
        data: action.payload.apps,
        pages: action.payload.numPages
      })
    default:
      return state
  }
}

export default mobileAppsReducer



// WEBPACK FOOTER //
// ./src/reducers/mobile-apps-reducer.js